import type { EventDetails } from "@/modules/events/types/eventDetailsApi"
import type { FunctionComponent } from "react"

import { useParams } from "next/navigation"

import { Heading } from "@jobteaser/spark/components/Heading"
import { Text } from "@jobteaser/spark/components/Text"

import { useEventDetailsData } from "@/modules/events/hooks/useEventDetailsData"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import bodyStyles from "./Body.module.css"

export const Speakers: FunctionComponent = () => {
  const { t } = useTranslation(["event_details"])
  const { eventSlug } = useParams<{ eventSlug: string }>()
  const event = useEventDetailsData(eventSlug)

  const { speakers } = event as EventDetails

  const formattedSpeakers = speakers.length > 0 ? speakers.join(", ") : ""

  return (
    <>
      <Heading as="h2" variant="title2" className={bodyStyles.title} weight="bold" data-testid="event-details-speakers">
        {t("event_details.speakers")}
      </Heading>
      <Text variant="body1" data-testid="event-details-speakers-list">
        {formattedSpeakers}
      </Text>
    </>
  )
}
